export default __webpack_public_path__ + "static/media/MichaelScott.bf7de583.png";